import React, { useCallback } from 'react';

import ConfirmationDialog from '../../../common/ConfirmationDialog/ConfirmationDialog';
import ContactSupport from '../../../common/Labels/ContactSupportLink';
import Label from '../../../common/Labels/Label';

export const UserRemovalModal = ({
  error = null,
  userId = {},
  onUserRemoved = () => {},
  showDialog = false,
  onDialogToggle = () => {},
}) => {
  const onConfirm = useCallback(() => {
    onUserRemoved(userId);
  }, [userId, onUserRemoved])

  return (
    <ConfirmationDialog
      title="Delete User"
      confirmButtonText="Delete"
      confirmButtonType="danger"
      showDialog={showDialog}
      onDialogToggle={onDialogToggle}
      modalAnimationKey="delete-user-modal"
      onConfirm={onConfirm}
      error={error}
    >
      <div className="w-small-modal p-2 m-1">
        <Label>
          The selected user will be deleted from Wallaroo, any record referencing the user will show as “Deleted User” Are you sure?
        </Label>
        {
          error && (
            <div className="p-2">
              <Label color="error" size="sm">
                Error while deleting the user. Please try again or <ContactSupport>contact support</ContactSupport> if the issue persists.
              </Label>
            </div>
          )
        }
      </div>
    </ConfirmationDialog>
  )
};

export default UserRemovalModal;
